module.exports = __webpack_public_path__ + "img/slide-offer202402-mob-en.b7742e9a.png";